import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { LetsTalkProvider } from "@/components/site/LetsTalkModal";
import Landing from "@/pages/Landing";
import CaseStudy from "@/pages/CaseStudy";
import LoopLab from "@/pages/LoopLab";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

function App() {
  useLenis();
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <LetsTalkProvider>
            <ScrollManager />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/loop-lab" element={<LoopLab />} />
              <Route path="/work/:slug" element={<CaseStudy />} />
            </Routes>
          </LetsTalkProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
